import { useMemo } from 'react';

/**
 * Get an ID for linking/testing an editor
 * @param path of editor to convert to ID
 * @param id if already chosen to easily override default path-based ID
 * @returns kebab-case id string
 */
export function useEditorId(path: string[], id?: string) {
  // useMemo saves the work of re-calculating this if nothing changes,
  // and if we add something more complex, avoids spitting arrays out for garbage collection on render.

  id = useMemo(() => id || path[path.length - 1].replace(/ /g, '-').toLowerCase(), [id, path]);
  return [id];
}
